"use client";

import { ExperimentFlags } from "@shared/utils.experimentation";
import { useFeatureFlag } from "hooks";
import { useEffect } from "react";
import { track } from "tracking";

type DigiohInboundEvent = {
  action: "DIGIOH_VIEWED" | "DIGIOH_DISMISSED";
  payload: {
    boxId: string;
  };
};

function handleMessageEvent(e: MessageEvent<DigiohInboundEvent>) {
  switch (e.data.action) {
    /**
     * The calling code at digioh custom js https://account.digioh.com/HQ/BoxCustomJavascript
     * After display: window.parent.postMessage({ action: 'DIGIOH_VIEWED', payload: { boxId: boxapi.getId() } });
     */
    case "DIGIOH_VIEWED": {
      track({
        event: "Page Element Viewed",
        properties: {
          location_type: "digioh_communications_opt_in_pop_up",
          module_content: "digioh_communications_opt_in_pop_up",
          module_id: e.data.payload.boxId
        }
      });
      break;
    }
    /**
     * The calling code at digioh custom js https://account.digioh.com/HQ/BoxCustomJavascript
     * After close: window.parent.postMessage({ action: 'DIGIOH_DISMISSED', payload: { boxId: boxapi.getId() } });
     */
    case "DIGIOH_DISMISSED": {
      track({
        event: "Page Element Clicked",
        properties: {
          location_type: "digioh_communications_opt_in_pop_up",
          module_content: "digioh_communications_opt_in_pop_up",
          module_id: e.data.payload.boxId,
          module_content_details: "dismiss"
        }
      });
      break;
    }
  }
}

export const DigiohLightboxScript = () => {
  const [loading, showDigiohPopup] = useFeatureFlag(
    ExperimentFlags.SHOW_DIGIOH_POPUP,
    0
  );

  useEffect(() => {
    if (!loading && showDigiohPopup !== 0) {
      const script = document.createElement("script");
      script.src =
        "https://www.lightboxcdn.com/vendor/5b411e43-b610-40f4-9f96-7be310aa03a8/lightbox_inline.js";
      script.async = true;
      script.type = "text/javascript";
      script.id = "digioh-lightbox-popup";
      document.head.appendChild(script);

      window.addEventListener("message", handleMessageEvent);

      return () => {
        document.getElementById("digioh-lightbox-popup")?.remove();
        window.removeEventListener("message", handleMessageEvent);
      };
    }
  }, [loading, showDigiohPopup]);

  return null;
};
